<template>
  <div>
    <v-row justify="center">
      <v-dialog
        class="modal_medium"
        v-model="visible"
        content-class="v-dialog--custom"
        persistent
      >
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">REPORTE DE INTEGRADORES</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <p>
                      Seleccionar la empresa para exportar sus integradores.
                    </p>
                    <!-- {{ this.form.company }} -->
                    <v-alert
                      class="alert_custom"
                      v-if="msjError"
                      type="warning"
                    >
                      <div class="ctn_alert">
                        <v-btn @click="textInfo.flag = 0" color="#000" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <p class="ctn_alert_text">
                          {{ textInfo.text }}
                        </p>
                      </div>
                    </v-alert>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox
                      ref="company"
                      v-model="form.company"
                      :items="itemsData"
                      :search-input.sync="search"
                      item-value="_id"
                      item-text="name"
                      label="Empresas"
                      placeholder="Digite el nombre de la empresa"
                      @change="actionClear"
                      clearable
                      :rules="nameRules"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click="this.closeModal">Cerrar</v-btn>
                <v-btn
                  v-if="hideBtn == false"
                  :disabled="isDisable"
                  @click="validate"
                  large
                  color="primary"
                  >Validar
                </v-btn>
                <download-csv
                  v-if="visibleBtn == true"
                  class="btn btn-default"
                  :data="response"
                  name="reporte_integradores.csv"
                >
                  <v-btn @click="this.registerForm" large color="primary"
                    >DESCARGAR</v-btn
                  >
                </download-csv>
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions } from "vuex";
export default {
  name: "ClientReportComp",
  components: {},
  props: ["visible"],
  data() {
    return {
      textInfo: { flag: 0, text: "No exisite ningun valor" },
      response: [],
      form: {
        company: null,
      },
      search: "",
      itemsData: [],
      totalItems: 0,
      page: 0,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      arrayCompany: null,
      valid: true,
      visibleBtn: false,
      hideBtn: false,
      isDisable: false,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        if(this.$refs.form) {
          this.$refs.form.reset();
        }
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
    // evento despues de nueva estacion
    this.$root.$on("reload", async () => {
      await this.getJsonData();
    });
    await this.getJsonData();
  },
  watch: {
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["alertSnackbar", "exportIntegratorAll"]),
    getLoadBtn(dato) {
      if (dato > 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    actionClear() {
      this.itemsData = [];
      this.search = "";
      this.isDisable = false;
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)

          axios
            .get(
              `company/list?page=${this.pagination.page}&search=${this.search}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsData = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    closeModal() {
      this.$refs.form.reset();
      this.form.company = null;
      this.response = [];
      this.show = false;
      this.visibleBtn = false;
      (this.hideBtn = false), (this.isDisable = true);
      this.textInfo = {
        flag: 0,
      };
    },
    async validate() {
      this.isDisable = true;
      this.response = await this.exportIntegratorAll({
        company: this.form.company,
      });

      //console.log('-response-', this.response)
      if (this.$refs.form.validate() && this.response.length > 0) {
        this.visibleBtn = true;
        this.hideBtn = true;
        this.isDisable = false;
      } else {
        this.visibleBtn = false;
        this.isDisable = true;

        this.textInfo = {
          flag: 1,
          text: "No se encontró ninguna información con los parámetros establecidos",
        };
      }
    },
    async registerForm() {
      try {
        if (this.response.length > 0) {
          this.textInfo = {
            flag: 2,
          };
          this.closeModal();
          this.$root.$emit("reload"); // parametro update tabla
          this.alertSnackbar({
            snackbar: true,
            text: "Se genero un reporte de un dispositivo.",
          });
        } else {
          //console.log('no se encontro valores')
          this.textInfo = {
            flag: 1,
            text: "No se encontró ninguna información con los parámetros establecidos",
          };
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: 1,
          text: "ocurrio un error con el servidor.",
        });
      }
    },
  },
  computed: {
    msjError() {
      if (this.textInfo.flag != 0) {
        return this.textInfo;
      } else {
        return null;
      }
    },

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
.ctn_btn_shop {
  display: flex;
  flex-direction: row;
}
</style>
